import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class TreeService {
  constructor(private http: HttpClient) { }
  GetRCATREEOptionValues(caseKey: any, PatientType: any, diagram: any) {
    return this.http.get(AUTH_API +  `/case/GetRCATREEOptionValues?PatientType=${PatientType}&CaseKey=${caseKey}&cas_rcaDiagramOption=${diagram}`)
  }
  GetFishBoneDiagramValues(caseKey: any, PatientType: any, diagram: any) {
    return this.http.get(AUTH_API + `/case/GetRCAFishBoneDiagram?PatientType=${PatientType}&CaseKey=${caseKey}&cas_rcaDiagramOption=${diagram}`);
  }
  getRCACountermeasuresByCaseKey(caseKey: any) {
    return this.http.get(AUTH_API + `/case/getRCACountermeasuresByCaseKey?cas_CaseKey=${caseKey}`);
  }
}